import cloneDeep from 'lodash.clonedeep'

export default {
    namespaced: true,

    state: {
        errors: [],
    },

    getters: {
        getErrors(state) {
            return state.errors
        },
    },

    mutations: {
        setErrors(state, errors) {
            state.errors = errors
        },

        clearErrors(state) {
            state.errors = []
        },

        removeErrorByField(state, path) {
            const errorsCopy = cloneDeep(state.errors)
            delete errorsCopy[path]
            state.errors = errorsCopy
        },
    },

    actions: {
        setErrors(Store, errors) {
            Store.commit('setErrors', errors)
        },

        clearErrors(Store) {
            Store.commit('clearErrors')
        },

        removeErrorByField(Store, path) {
            Store.commit('removeErrorByField', path)
        },
    },
}
